import * as yup from 'yup';

export const bookingSchemaValidation = yup.object().shape({
  rejectionReason: yup.string().max(100).label('Rejection reason').required(),
});
